export const productsData = {
  "haio-alpha": {
    id: 1,
    name: "Ha1o Alpha",
    price: 699,
    comparePrice: 999,
    discount: 30,
    reviewsCount: 54,
    rating: 4.5,
    sizes: ["100 ML", "20 ML"],
    description: "A bold and timeless fragrance designed for confident individuals.",
    images: [
      "https://picsum.photos/seed/lumenaura-alpha-1/800/800",
      "https://picsum.photos/seed/lumenaura-alpha-2/800/800",
    ],
    reviews: [
      {
        id: 1,
        name: "John D.",
        rating: 5,
        text: "Absolutely love this perfume. Very fresh and long-lasting.",
        date: "2025-07-12",
      },
      {
        id: 2,
        name: "Sarah M.",
        rating: 4,
        text: "Great scent but delivery took 2 extra days.",
        date: "2025-08-01",
      },
    ],
  },

  "haio-date": {
    id: 2,
    name: "Ha1o Date",
    price: 749,
    comparePrice: 999,
    discount: 25,
    reviewsCount: 21,
    rating: 4,
    sizes: ["100 ML"],
    description: "A romantic fragrance with smooth and warm notes, perfect for evenings.",
    images: [
      "https://picsum.photos/seed/lumenaura-date-1/800/800",
      "https://picsum.photos/seed/lumenaura-date-2/800/800",
    ],
    reviews: [
      {
        id: 1,
        name: "Lisa P.",
        rating: 4,
        text: "Beautiful scent! My partner loved it.",
        date: "2025-08-05",
      },
    ],
  },

  "haio-day": {
    id: 3,
    name: "Ha1o Day",
    price: 599,
    comparePrice: 899,
    discount: 33,
    reviewsCount: 33,
    rating: 4.2,
    sizes: ["50 ML", "100 ML"],
    description: "A bright, energetic fragrance ideal for daily wear.",
    images: [
      "https://picsum.photos/seed/lumenaura-day-1/800/800",
      "https://picsum.photos/seed/lumenaura-day-2/800/800",
    ],
    reviews: [
      {
        id: 1,
        name: "Michael R.",
        rating: 5,
        text: "My new everyday go-to scent. Fresh and clean.",
        date: "2025-09-01",
      },
      {
        id: 2,
        name: "Anita K.",
        rating: 4,
        text: "Lovely fragrance but I wish it lasted a bit longer.",
        date: "2025-09-10",
      },
    ],
  },
};
